import { useMutation } from "react-query";
import { massUploadOfficeSettings } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

const useMassUploadOfficeSettings = () => {
  return useMutation((data) => massUploadOfficeSettings(data));
};
export default useMassUploadOfficeSettings;
